import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage3 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(50, 50);
        this.pushPlayer(50, 50);
        this.asCameraCenter();

        //外壁
        this.pushWall(-400, -400, 200, 1000);
        this.pushWall(-200, -400, 600, 200);
        this.pushWall(-200, 400, 600, 200);
        this.pushWall(400, 0, 200, 600);
        this.pushWall(600, 0, 3400, 200);
        this.pushWall(200, -2800, 3800, 200);
        this.pushWall(200, -2600, 200, 2200);
        this.pushWall(3800, -2600, 600, 200);
        this.pushWall(4400, -2600, 200, 1000);
        this.pushWall(3800, -1800, 600, 200);
        this.pushWall(3800, -1600, 200, 1600);

        //中身の壁
        this.pushWall(600, -400, 200, 400);
        this.pushWall(400, -1400, 200, 800);
        this.pushWall(600, -800, 400, 200);
        this.pushWall(800, -1200, 400, 200);
        this.pushWall(1000, -1000, 200, 800);
        this.pushWall(1400, -200, 600, 200);
        this.pushWall(1400, -600, 400, 200);
        this.pushWall(1400, -800, 200, 200);
        this.pushWall(1400, -1000, 800, 200);
        this.pushWall(2000, -800, 200, 400);
        this.pushFakePanel(2200, -800, 200, 200);
        this.pushWall(2200, -600, 200, 400);
        this.pushWall(2400, -1000, 400, 200);
        this.pushWall(2600, -800, 400, 200);
        this.pushWall(2600, -600, 200, 600);
        this.pushWall(3000, -400, 200, 400);
        this.pushWall(3200, -600, 200, 400);
        this.pushWall(3400, -600, 200, 200);
        this.pushWall(3600, -200, 200, 200);
        this.pushWall(3600, -1600, 200, 800);
        this.pushFakePanel(3400, -1200, 200, 400);
        this.pushWall(3200, -1200, 200, 400);
        this.pushWall(3200, -1600, 400, 200);
        this.pushWall(3000, -2200, 200, 1200);
        this.pushWall(2600, -2200, 400, 200);
        this.pushWall(2200, -1400, 200, 400);
        this.pushWall(2200, -2200, 200, 600);
        this.pushWall(2400, -1800, 400, 200);
        this.pushWall(2600, -1600, 200, 400);
        this.pushFakePanel(1400, -2600, 600, 200);
        this.pushWall(1400, -2400, 1400, 200);
        this.pushWall(1400, -2200, 400, 200);
        this.pushWall(1600, -2000, 400, 200);
        this.pushWall(1800, -1800, 200, 400);
        this.pushWall(1400, -1400, 600, 200);
        this.pushWall(800, -1600, 400, 200);
        this.pushWall(600, -1800, 1000, 200);
        this.pushSquare(1000, -2000, 200, 200);
        this.pushWall(400, -2200, 800, 200);
        this.pushWall(600, -2400, 400, 200);
        this.pushWall(3000, -2600, 400, 200);
        this.pushWall(3400, -2200, 200, 400);
        this.pushWall(3600, -2400, 200, 400);

        this.pushSignboard(1650, -1750, [
            new Speech({
                content: '<font style="color:#dd0000">自分の仕事は主に外でやるものだ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(450, -2350, [
            new Speech({
                content: '<font style="color:#00dd00">記憶の穴</font>はここからほぼ真右にあります。',
                speakerName: "看板",
            }),
            new Speech({
                content: "さて、どうやって行くのか。",
            }),
            new Speech({
                content: "道がどこにあるか観察してもいいかも。",
                speakerName: "謎の声",
            }),
        ]);
        this.pushSignboard(3250, -1350, [
            new Speech({
                content: '<font style="color:#dd0000">自分の仕事は力仕事だ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(3250, -150, [
            new Speech({
                content: "ここの少し上の方に通れる壁がありますよ。",
                speakerName: "看板",
            }),
            new Speech({
                content: "もしかしてここに来るまでにあったのか。",
            }),
        ]);
        this.pushSignboard(2250, -950, [
            new Speech({
                content: '<font style="color:#dd0000">自分の仕事は"く"で終わる。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(1650, -750, [
            new Speech({
                content: '<font style="color:#00dd00">記憶の穴</font>を目指すなら左上に行ったほうがいいよ。',
                speakerName: "看板",
            }),
            new Speech({
                content: "しかしどこ行くにしたってここは結構入り組んでいるようだ。",
            }),
            new Speech({
                content: "とはいえ、覚えておくべき情報ね。",
                speakerName: "謎の声",
            }),
        ]);

        this.pushGoal(4050, -2150, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
